<script setup lang="ts">
import { locale } from 'dayjs'
import { useI18n } from 'vue-i18n'

import LoadingModal from '~/components/molecules/LoadingModal.vue'
import TheSnackbar from '~/components/organisms/TheSnackbar.vue'
import { useAppEnv } from '~/composables/useAppEnv'
import { useLoading } from '~/composables/useLoading'

const siteTitle = 'Teachme Check'

// https://nuxt.com/docs/getting-started/seo-meta#title-template
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${siteTitle} - ${titleChunk}` : siteTitle
  },
})

const { isProduction, appEnv } = useAppEnv()

const { isActive } = useLoading()

// @see plugins/dayjs.client.ts
const i18n = useI18n()
watchEffect(() => locale(i18n.locale.value))
</script>

<template>
  <div>
    <div v-if="!isProduction" class="env-notification">NON-PRODUCTION / {{ appEnv }}</div>
    <TheSnackbar />
    <div id="page">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </div>
    <LoadingModal id="loading" :is-active="isActive" />

    <div id="preview"></div>
    <div id="messageDialog"></div>
    <div id="dialog"></div>
  </div>
</template>

<style scoped lang="scss">
.env-notification {
  @include textToken.label-medium;

  position: fixed;
  top: env(safe-area-inset-top, 0px);
  left: 50%;
  z-index: 5;
  transform: translateX(-50%);
  max-width: 100%;
  padding: spacingToken.$spacing-x3s spacingToken.$spacing-m;
  border-radius: 0 0 4px 4px;
  // Environment-only colors, intentionally separate from product design tokens.
  background-color: hsl(204, 86%, 53%);
  color: #fff;
  overflow-wrap: anywhere;
  pointer-events: none;
  user-select: none;
}

#loading {
  position: fixed;
  z-index: 4;
}

#preview {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
}

#messageDialog {
  position: absolute;
  z-index: 2;
}

#dialog {
  position: absolute;
  z-index: 1;
}

#page {
  position: relative;
  z-index: 0;
}
</style>
